import {
  saveAs
} from 'file-saver';
import Papa from 'papaparse';

export function CvsFileGenerator(data) {
  const csv = Papa.unparse(data);
  const blob = new Blob([csv], {
    type: 'text/csv;charset=utf-8;'
  });
  saveAs(blob, 'data.csv');
}

export function downloadCSV(sendUrl) {
  const url = sendUrl; // Use the full URL from your image

  // Create a temporary link element
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'ExportAll.csv'); // Set the file name

  // Append the link to the body (required for Firefox)
  document.body.appendChild(link);

  // Programmatically click the link to trigger the download
  link.click();

  // Clean up and remove the link
  document.body.removeChild(link);
};

export function downloadPDF(data) {
  const pdfUrl = data;
  const fileName = 'download.pdf'
  saveAs(pdfUrl, fileName)
}

export function CurrentPeriod() {
  // Load current period (YYYYMM)
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}${month}`;
}

export function validatePeriodData(period, required) {
  let periodError = false;
  let periodErrorMessage = '';

  if (!period && required) {
    periodError = true;
    periodErrorMessage = 'Periodo is requied';
  }

  if (period) {
    const regex = /^\d{6}$/;
    if (!regex.test(period)) {
      periodError = true;
      periodErrorMessage = 'Periodo inválido (YYYYMM)';
    }
    const year = parseInt(period.substring(0, 4), 10);
    const month = parseInt(period.substring(4, 6), 10);
    if (month < 1 || month > 12) {
      periodError = true;
      periodErrorMessage = 'Mes inválido. Sólo puede ser entre 01 y 12';
    }
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const enteredDate = new Date(year, month - 1);
    if (enteredDate > new Date(currentYear, currentMonth - 1)) {
      periodError = true;
      periodErrorMessage = 'No se puede ingresar data futura';

    }
    return {
      periodError,
      periodErrorMessage
    }
  } else {
    return {
      periodError,
      periodErrorMessage
    }
  }
}

export function formatRutData(field) {
  let value = this[field];
  // Remove non-numeric characters and transform to upper case for validation
  value = value.replace(/[^\dkK]/g, '').toUpperCase();
  if (value.length === 0) {
    this[`${field}Error`] = false; //remove error if the input is empty
    this[field] = value;
    return;
  }
  if (value.length > 1) {
    const rut = value.slice(0, -1);
    const dv = value.slice(-1);
    this[field] = `${rut}-${dv}`;
    this[`${field}Error`] = !this.validateRUT(this[field]);
  } else {
    this[field] = value;
    this[`${field}Error`] = value.length === 1 ? !this.validateRUT(`${value.slice(0, -1)}-${value.slice(-1)}`) : true;
  }
}

export function validateRUTData(rut) {
  if (!/^[0-9]+-[0-9kK]{1}$/.test(rut)) return false;
  const parts = rut.split('-');
  const dv = parts[1];
  const rutNumber = parts[0].replace(/\./g, ''); // Remove dots
  let T = rutNumber;
  let M = 0;
  let S = 1;
  for (; T; T = Math.floor(T / 10)) {
    S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
  }
  const calculatedDV = S ? S - 1 : 'k';
  return dv.toLowerCase() === calculatedDV.toString();
}



// WEBPACK FOOTER //
// ./src/services/common.js